import { createStore, applyMiddleware, Middleware, Store } from "redux";
// import { createLogger } from "redux-logger";
import ReduxThunk from "redux-thunk";
import rootReducer from "./rootReducer";
import { ISearchState } from "./search/types";
import { IRobotState } from "./robot/types";

export interface IRootState {
  search: ISearchState;
  robots: IRobotState;
}

// const logger: Middleware = createLogger();
const middlewares: Array<Middleware> = [ReduxThunk /*logger*/];
const store: Store = createStore(rootReducer, applyMiddleware(...middlewares));

export default store;
